define('container/initialisers/ReturnInitialiser',[],function() {

    'use strict';

    /**
     * Return the module as is, ignoring any args.
     */
    function ReturnInitialiser() {
    }

    ReturnInitialiser.prototype.canInitialise = function(extensionApi) {
        return extensionApi.serviceDefinition.init === 'return';
    };

    ReturnInitialiser.prototype.initialise = function(instanceCreatedCallback, loadedModule) {

        instanceCreatedCallback(loadedModule);

        return loadedModule;

    };

    return ReturnInitialiser;

});

